import styled from 'styled-components';

export const StyledContainer = styled('div')`
	display: flex;
	justify-content: end;
	align-items: center;
	gap: 22px;
`;

export const Label = styled.h5`
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	color: rgba(0, 0, 0, 0.54);
	margin-top: 0rem;
	margin-bottom: 0;
	white-space: nowrap;
`;

export const LabelBold = styled.h5`
	font-style: normal;
	font-weight: bold;
	font-size: 12px;
	line-height: 16px;
	color: rgba(0, 0, 0, 0.54);
	margin-top: 0rem;
	margin-bottom: 0;
	white-space: nowrap;
`;
